exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h2,\ninput {\n  margin-bottom: 5%; }\n\nbutton {\n  align-self: flex-end;\n  max-width: 300px;\n  background-color: #0a244f;\n  color: #42ebf4; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/hotels/components/Hotel.scss
// module id = 93
// module chunks = 0